// src/services/authUtils.js
export const getJwtPayload = () => {
  const t = localStorage.getItem("token");
  if (!t) return {};
  try {
    const payload = t.split(".")[1]?.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(payload);
    return JSON.parse(json);
  } catch {
    return {};
  }
};

export const isSuperAdmin = () => {
  const p = getJwtPayload();
  return p.esSuperAdmin === true || p.esSuperAdmin === "true";
};
